import type { RouteObject } from 'react-router';

import { SettingsIndexPage } from './SettingsIndex';

/**
 * `/settings` — the index of the two-route settings feature.
 *
 * It sits inside the console layout route, which already runs the guard chain.
 * The console does **not** pre-compute the `admin` outcome: an operator who
 * reaches this page is offered the services their session actually administers,
 * which for an `operator` is none, and the empty state says so in one sentence
 * rather than through nine refusals.
 */
export const settingsIndexRoute: RouteObject = {
  index: true,
  element: <SettingsIndexPage />,
};
